/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_PendingInputs */

const en_mobile_referral_pending = /** @type {(inputs: Mobile_Referral_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for this friend`)
};

const es_mobile_referral_pending = /** @type {(inputs: Mobile_Referral_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperando a este amigo`)
};

/**
* | output |
* | --- |
* | "Waiting for this friend" |
*
* @param {Mobile_Referral_PendingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_pending = /** @type {((inputs?: Mobile_Referral_PendingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_PendingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_pending(inputs)
	return en_mobile_referral_pending(inputs)
});